module.exports = __webpack_public_path__ + "img/photo-0010.9b145c06.jpg";